import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'vwc_recently_viewed';
const MAX_ITEMS = 12;

export const useRecentlyViewed = () => {
  const [recentIds, setRecentIds] = useState([]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) setRecentIds(JSON.parse(stored));
    } catch { /* ignore */ }
  }, []);

  const trackView = useCallback((productId) => {
    setRecentIds((prev) => {
      const filtered = prev.filter((id) => id !== productId);
      const next = [productId, ...filtered].slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { recentIds, trackView };
};
